import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';

import { ResetUser, SetUser } from './user-store.actions';
import { IUserStore } from './user-store.model';

@State<IUserStore>({
  name: 'user',
  defaults: null
})
@Injectable()
export class UserStore {

  @Action(SetUser)
  setUser(
    { setState }: StateContext<IUserStore>,
    { payload }: SetUser
  ): void {
    setState(payload);
  }

  @Action(ResetUser)
  resetUser(
    { setState }: StateContext<IUserStore>
  ): void {
    setState(null);
  }
}
